import React, { useEffect } from "react";

const Skills = () => {
  useEffect(() => {
    // Initialize easy pie chart if jQuery and the plugin are available
    // Delay the initialization to ensure DOM is fully loaded
    const timer = setTimeout(() => {
      if (window.jQuery && window.jQuery.fn.easyPieChart) {
        try {
          window.jQuery('.js-chart').easyPieChart({
            scaleColor: false,
            lineWidth: 4,
            lineCap: 'butt',
            barColor: '#FF9000',
            trackColor: '#f5f5f5',
            size: 160,
            animate: 1000
          });
        } catch (error) {
          console.log('EasyPieChart initialization error:', error);
        }
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div id="fh5co-skills" className="animate-box">
      <div className="container">
        <div className="row">
          <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
            <h2>Skills</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="progress-wrap">
              <h3><span className="name-left">C++</span><span className="value-right">90%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-1 progress-bar-striped active" role="progressbar"
                  aria-valuenow="90" aria-valuemin="0" aria-valuemax="100" style={{ width: '90%' }}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">Python</span><span className="value-right">85%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-2 progress-bar-striped active" role="progressbar"
                  aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{ width: '85%' }}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">React</span><span className="value-right">80%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-3 progress-bar-striped active" role="progressbar"
                  aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{ width: '80%' }}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">Kafka</span><span className="value-right">75%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-4 progress-bar-striped active" role="progressbar"
                  aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ width: '75%' }}>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="progress-wrap">
              <h3><span className="name-left">AWS</span><span className="value-right">85%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-5 progress-bar-striped active" role="progressbar"
                  aria-valuenow="85" aria-valuemin="0" aria-valuemax="100" style={{ width: '85%' }}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">Docker</span><span className="value-right">90%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-striped active" role="progressbar"
                  aria-valuenow="90" aria-valuemin="0" aria-valuemax="100" style={{ width: '90%' }}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">Kubernetes</span><span className="value-right">80%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-1 progress-bar-striped active" role="progressbar"
                  aria-valuenow="80" aria-valuemin="0" aria-valuemax="100" style={{ width: '80%' }}>
                </div>
              </div>
            </div>
            <div className="progress-wrap">
              <h3><span className="name-left">TensorFlow</span><span className="value-right">75%</span></h3>
              <div className="progress">
                <div className="progress-bar progress-bar-3 progress-bar-striped active" role="progressbar"
                  aria-valuenow="75" aria-valuemin="0" aria-valuemax="100" style={{ width: '75%' }}>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skills;
